export const COMPANY = 'COMPANY';
export const USERS_AND_TEAMS = 'USERS_AND_TEAMS';
export const OWNER = 'OWNER';